export function buildRouteRequest(
  items: number[][],
): google.maps.DirectionsRequest {
  const origin = items[0];
  const destination = items[items.length - 1];
  const waypoints = items.slice(1, -1).map(([lat, lng]) => ({
    stopover: true,
    location: { lat, lng },
  }));
  return {
    origin: { lat: origin[0], lng: origin[1] },
    destination: { lat: destination[0], lng: destination[1] },
    waypoints,
    optimizeWaypoints: false,
    travelMode: 'DRIVING' as google.maps.TravelMode.DRIVING,
  };
}
